import { USER_TYPE } from '../../utils/constants/user';

export const SOURCE = {
    LENDER_REQ: 'lenderReq',
    BORROWER_REQ: 'borrowerReq',
};

export const COMPOSE_EMAIL_SOURCE = {
    LENDER_QUERY: 'LENDER_QUERY',
    DEALS_PAGE: 'DEALS_PAGE',
    DASHBOARD_HEADER: 'DASHBOARD_HEADER',
    DATA_PENDING: 'DATA_PENDING',
    LEADS: 'LEADS',
};

// Tooltip copy explaining why the "Email Lender" button is disabled (RECUR-27563 R2).
export const EMAIL_LENDER_DISABLED_REASONS = {
    NONE_SELECTED: 'Select a lender in the "Requested By" filter to enable Email Lender',
    MULTIPLE_SELECTED: 'Select exactly one lender in the "Requested By" filter to enable Email Lender',
    NO_MATCHING_DEAL: 'The selected filter is not a lender, or that lender has no visible pending deal',
    MULTIPLE_DEALS: 'The selected lender has more than one deal here — narrow the filter to a single deal',
} as const;

// Single source of truth for the (lender, deal) shape shared with EntityRequirement.lenderDeals.
// lenderName is optional: the aica producer omits it (@JsonInclude(NON_NULL)) when the lenderId
// has no OrganisationMaster name. The enable rule keys on lenderId, so readers coalesce the name.
export interface LenderDealRef {
    lenderId: string;
    lenderName?: string;
    lenderDealId: string;
}

export interface RequestedByFilterSource {
    lenderDeals?: LenderDealRef[];
    requestedBy?: string[];
}

export interface FilterOption {
    value: string;
    label: string;
}

export const TAB_STATE = {
    ACTIVE: 'active',
    ARCHIVED: 'archived',
} as const;

export type TabState = (typeof TAB_STATE)[keyof typeof TAB_STATE];

export type LenderRequirementStatus = 'PENDING' | 'COMPLETE'; // Assuming COMPLETE is the other status besides PENDING

export const REQUIREMENT_STATUS = {
    PENDING: 'PENDING' as LenderRequirementStatus,
    COMPLETE: 'COMPLETE' as LenderRequirementStatus,
} as const;

export const isIncomplete = (req: { status: LenderRequirementStatus }): boolean => req.status !== REQUIREMENT_STATUS.COMPLETE;

export interface UpdateLenderRequirementPayload {
    id: number;
    status: LenderRequirementStatus;
    dataType: string;
    updatedBy: string;
}

export enum AicaChaseStatus {
    ACTIVE = 'ACTIVE',
    ATTEMPTS_OVER = 'ATTEMPTS_OVER',
    TURNED_OFF = 'TURNED_OFF',
    NOT_APPLICABLE = 'NOT_APPLICABLE',
}

export interface UpdateAicaChaseStatusPayload {
    orgId: string;
    status: AicaChaseStatus;
    journey: string;
}

export interface UpdateLenderAicaChaseStatusPayload {
    dealId: string;
    status: AicaChaseStatus;
    lastUpdatedBy: string;
    journey: string;
}

export const ADD_PARTNER_ALLOWED_ACCOUNT_TYPES = [USER_TYPE.INVESTOR, USER_TYPE.ADMIN_TEAM];

export const LEAD_PARTNER_FIELD = 'customFields.partnerOrgId';

export const ADD_PARTNER_LABELS = {
    TRIGGER: 'Add Partner',
    ADD_NEW: 'Add New Partner',
    SEARCH_PLACEHOLDER: 'Search Partner',
    NO_PARTNERS: 'No partners found',
    MODAL_HEADING: 'Add Partner',
} as const;

export const USER_LIST_FALLBACK = {
    COMPANY: 'Company',
    PARTNER: 'Partner',
} as const;

export const USER_LIST_EMPTY = {
    COMPANY_USER: 'No company user added yet',
    PARTNER: 'No partner added yet',
    PARTNER_USER: 'No partner user added yet',
} as const;

export const ADD_PARTNER_MESSAGES = {
    TAG_SUCCESS: 'Partner tagged successfully',
    ALREADY_EXISTS_SUFFIX: ' already exists — tagged to this lead.',
    NAME_MATCH_NOT_ADDED_SUFFIX: ' was not added — use Add User in Manage Partners.',
    CREATED_NOT_TAGGED: "Partner created, but it couldn't be tagged. Select it from Add Partner.",
} as const;
